import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthRouteProvider } from "./contexts/AuthRouteContext";
import StripeProviderWrapper from './contexts/StripeProviderWrapper';
import { AuthTokenProvider } from './contexts/AuthTokenContext';
import { BankingProvider } from './contexts/BankingContext';
import { UserProvider } from './contexts/UserContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <AuthTokenProvider>
    <AuthRouteProvider>
          <UserProvider>
            <BankingProvider>
              <App />
            </BankingProvider>
          </UserProvider>
    </AuthRouteProvider>
    </AuthTokenProvider>
  // </React.StrictMode>
);
